// 000-099: Generic Components
export enum componentType {
	// 00X => Generic Entry components
	entryText = 0,
	entryTextArea = 1,
	entryTextAutocomplete = 2,
	entryTextWithLookup = 3,
	entryTextWithValidation = 4,
	entryNumber = 5,
	entryDate = 6,
	entryTime = 7,

	// 01X => Formatted Entry components
	entryCurrency = 10,
	entryPhone = 11,
	entryEmailAddress = 12,
	entryAddress = 13,
	entryAddressAutocomplete = 14,
	entryZip = 15,
	entrySsn = 16,
	entrySecret = 17,

	// 02X => Selector components
	entryCheckbox = 20,
	entryLabeledCheckbox = 21,
	entryBoolean = 22,
	entryNullableBoolean = 23,
	entryDropdown = 24,
	radioButtonList = 25,
	panelSelector = 26,
	dateSelector = 27,
	monthSelector = 28,

	// 03X => Photo/Audio Capture components
	photoCapture = 30,
	selfiePhotoCapture = 31,
	mobilePhotoCapture = 32,
	audioRecording = 33,
	blinkId = 34,
	mobileOnlyPhotoCapture = 35,

	// 04X => Document/Signature components
	fileUpload = 40,
	documentTypeUpload = 41,
	documentReview = 42,
	entrySignature = 43,
	entrySignDocument = 44,

	// 05X => Map components
	googleMapCapture = 50,
	currentLocationFinder = 51,

	// 06X => Button components
	button = 60,

	// 07X => Template components
	template = 70,
	bulletedTemplate = 71,
	htmlTemplate = 72,

	// 08X => Simple Display components
	text = 80,
	propertyDisplay = 81,
	propertyDateDisplay = 82,
	propertyDateOnlyDisplay = 83,
	propertyCurrencyDisplay = 84,
	title = 85,
	propertyTimeOnlyDisplay = 86,
	propertyPhotoDisplay = 87,

	// 09X => Complex Display components
	tablePropertyDisplay = 90,
	tableDateDisplay = 91,
	tableDateOnlyDisplay = 92,
	addressDisplay = 93,
	imageDisplay = 94,
	audioDisplay = 95,

	// 9XX => Dynamic Editor Display components (app specific)
	readOnlyDynamicEditor = 900,
}

export enum sectionType {
	standard = 0,
	iteratedEditable = 1,
	iterated = 2,
	disposition = 3,
	summary = 4,
}

export const ITERATED_SECTION_TYPES = [sectionType.iterated, sectionType.iteratedEditable];
